module.exports = __webpack_public_path__ + "img/glassquality_4.b342d540.png";